import Image from 'next/image'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { FreeMode, Navigation, Pagination, Scrollbar, Thumbs, Zoom } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/css/zoom'
import { Swiper, SwiperSlide } from 'swiper/react'

import { isBlank } from 'utils'

import Text from 'components/Text'

import { FullScreenToggle, Hint, MainSwiper, Root, ThumbsSwiper } from './ProductPhotos.style'
import MaxSvgA from './svg/max.svg'
import MinSvgA from './svg/min.svg'

const loader = ({ src, width, quality }) => {
  return `${src}&w=${width}&q=${quality || 75}&auto=format,compress`.replace(
    'cdn.shopify.com/s/files',
    'the-armoury-shopify.imgix.net'
  )
}

const ProductPhotos = ({ photos }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [fullscreen, setFullscreen] = useState(false)

  if (isBlank(photos)) return null

  const FullScreenToggleComponent = fullscreen ? MinSvgA : MaxSvgA

  return (
    <Root $fullscreen={fullscreen}>
      <FullScreenToggle
        $fullscreen={fullscreen}
        onClick={() => setFullscreen(!fullscreen)}
        title={fullscreen ? 'Exit full screen' : 'Full screen'}
      >
        <FullScreenToggleComponent width={20} height={20} />
      </FullScreenToggle>
      <MainSwiper $fullscreen={fullscreen}>
        <Swiper
          modules={[FreeMode, Navigation, Thumbs, Scrollbar, Zoom, Pagination]}
          slidesPerView={1}
          navigation
          thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
          zoom
        >
          {photos.map((url, index) => (
            <SwiperSlide key={index}>
              <div className="swiper-zoom-container">
                <Image
                  src={url}
                  width={833}
                  height={833}
                  alt=""
                  style={{ width: '100%', height: 'auto' }}
                  loader={loader}
                  sizes={fullscreen ? '100w' : '(min-width: 768px) 50w, 100w'}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </MainSwiper>
      <Hint>
        <Text size="xs">Double-click to zoom</Text>
      </Hint>
      {photos.length > 1 && (
        <ThumbsSwiper $fullscreen={fullscreen}>
          <Swiper
            modules={[FreeMode, Navigation, Thumbs, Scrollbar, Zoom, Pagination]}
            onSwiper={setThumbsSwiper}
            watchSlidesProgress
            spaceBetween={16}
            slidesPerView={5}
            freeMode={true}
            navigation
            pagination
          >
            {photos.map((url, index) => (
              <SwiperSlide key={index}>
                <Image src={url} width={154} height={154} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>
        </ThumbsSwiper>
      )}
    </Root>
  )
}

ProductPhotos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.string.isRequired),
}

ProductPhotos.defaultProps = {}

export default ProductPhotos
